import React from 'react'
import { TooltipProps } from 'recharts'

import { Paper, Typography } from '@material-ui/core'

import { tryParseNumber } from '../common/tsUtils'

export type LifecycleTooltipProps = TooltipProps<number | string, string>

export const LifecycleTooltip =
  ({active, payload, label}: LifecycleTooltipProps) => {
    if (!active || !payload?.length) {
      return null
    }

    const rows = payload.filter(p => (tryParseNumber(p.value) ?? 0) > 0)

    return (
      <Paper elevation={3} style={{padding: 12, maxWidth: 300}}>
        <Typography variant="subtitle2" gutterBottom>
          {label}
        </Typography>

        {
          rows.length === 0
          ? <Typography variant="caption" color="textSecondary">Нет событий в этом интервале</Typography>
          : rows.map((p, i) =>
            <Typography key={i} variant="body2" style={{color: p.color}}>
              {p.name}: <strong>{p.value}</strong>
            </Typography>)
        }
      </Paper>
    )
  }